exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container[data-v-3bbc9fb6] {\n    /* margin-right: auto;\n    margin-left: auto; */\n    width: 100%;\n    height: auto;\n}\n.panel2[data-v-3bbc9fb6], .panel21[data-v-3bbc9fb6] {\n    background: #fcfcfc;\n    border: solid 1px #dbdbdb;\n    /*margin-bottom: 5%;*/\n    padding-bottom: 25px;\n    padding-top: 10px;\n    padding-left: 20px;\n    padding-right: 20px;\n    float: left;\n    width: 100%;\n}\n*[data-v-3bbc9fb6] {\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n}\n.col-md-12[data-v-3bbc9fb6] {\n    float: right;\n    width: 100%;\n    height: 100%;\n    padding: 0px;\n}\n.col-md-4[data-v-3bbc9fb6] {\n  float: left;\n  width: 100%;\n  margin: 0px;\n}\n.list-block[data-v-3bbc9fb6] {\n    padding: 0px 0px 0px 0px;\n    margin: auto;\n    width: 100%\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3bbc9fb6","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/user/CMChangePassword.vue
// module id = 1126
// module chunks = 2